// English Translation
import { TranslationKey } from './zh-TW';

export const enUS: TranslationKey = {
  common: {
    settings: 'Settings',
    refresh: 'Refresh',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    confirm: 'Confirm',
    loading: 'Loading...',
    online: 'Online',
    offline: 'Offline',
    unknown: 'Unknown',
    yes: 'Yes',
    no: 'No',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    enable: 'Enable',
    disable: 'Disable',
    enabled: 'Enabled',
    disabled: 'Disabled',
    apply: 'Apply',
    reset: 'Reset',
    clear: 'Clear',
    all: 'All',
    none: 'None',
    select: 'Select',
    selected: 'Selected',
    add: 'Add',
    remove: 'Remove',
    update: 'Update',
    create: 'Create',
    view: 'View',
    details: 'Details',
    name: 'Name',
    type: 'Type',
    status: 'Status',
    actions: 'Actions',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    finish: 'Finish',
    copy: 'Copy',
    copied: 'Copied',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',

    // Footer
    poweredBy: 'Powered by Ultron Turing',
    version: 'Ver:',
    build: 'Build:',

    // Theme
    lightMode: 'Light Mode',
    darkMode: 'Dark Mode',
  },

  sidebar: {
    dashboard: 'Overview',
    powerMeterView: 'Power Meter View',
    energy: 'Energy',
    climate: 'Environment',
    hvac: 'HVAC',
    lighting: 'Lighting',
    intelliSpace: 'IntelliSpace',
    alerts: 'Alerts',
    deviceLogs: 'Device Logs',
    generateReport: 'Generate Report',
    settings: 'System Settings',
    devices: 'Devices',
    home: 'Home',
    energyBoard: 'Energy Board',
    climateBoard: 'Climate Board',
    hvacBoard: 'HVAC Board',
    lightingBoard: 'Lighting Board',
    intelliSpaceBoard: 'IntelliSpace Board',
    apiKeySettings: 'API Key Settings',
  },

  dashboard: {
    // Titles
    title: 'Energy Monitoring Dashboard',
    energyMonitoring: 'Energy Monitoring',
    realTimePower: 'Real-time Power Monitoring',

    // Metrics
    power: 'Power',
    voltage: 'Voltage',
    current: 'Current',
    energy: 'Energy',
    powerFactor: 'Power Factor',
    frequency: 'Frequency',

    // Units
    watt: 'W',
    kilowatt: 'kW',
    volt: 'V',
    ampere: 'A',
    kilowattHour: 'kWh',
    hertz: 'Hz',

    // Status
    totalPower: 'Total Power',
    totalEnergy: 'Total Energy',
    todaysEnergy: 'Today\'s Energy',
    estimatedCost: 'Estimated Cost',
    deviceCount: 'Device Count',
    devices: 'Devices',
    onlineDevices: 'Online Devices',
    offlineDevices: 'Offline Devices',
    powerMeters: 'Power Meters',

    // Actions
    importDevices: 'Import Devices',
    manageDevices: 'Manage Devices',
    refreshData: 'Refresh Data',
    exportData: 'Export Data',

    // Time
    lastUpdate: 'Last Update',
    autoRefresh: 'Auto Refresh',
    refreshInterval: 'Refresh Interval',

    // Charts
    powerChart: 'Power Chart',
    energyChart: 'Energy Chart',
    trend: 'Trend',
    history: 'History',

    // Messages
    noDevices: 'No Devices',
    noData: 'No Data',
    loadingData: 'Loading Data...',
    selectDevices: 'Please Select Devices',

    // Card
    clickToViewChart: 'Click to view detailed chart',
    deviceOffline: 'Device Offline',
    noDataAvailable: 'No Data Available',

    // Device Manager
    deviceManager: 'Device Manager',
    importedDevices: 'Imported Devices',
    availableDevices: 'Available Devices',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    removeSelected: 'Remove Selected',

    // Footer
    poweredBy: 'Powered by Ultron Turing',
    version: 'Ver:',
    build: 'Build:',
    buildDate: 'Build Date',
    lastRefreshed: 'Last Refreshed',

    // Overview Dashboard (New Comprehensive Dashboard)
    overviewTitle: 'BUILDING ENERGY MANAGEMENT SYSTEM',
    realTimeLoad: 'Real-time Load',
    totalLoad: 'Total Load',
    highLoad: 'HIGH LOAD',
    mediumLoad: 'MEDIUM LOAD',
    lowLoad: 'LOW LOAD',
    vsYesterday: 'vs. Yesterday',
    dailyTrend: 'Daily Trend & Comparison',
    today: 'Today',
    yesterday: 'Yesterday',
    todayAccumulated: 'Today\'s Accumulated',
    dailyTarget: 'Daily Target',
    energyBreakdown: 'Breakdown & Sustainability',
    hvac: 'HVAC',
    lighting: 'Lighting',
    plugsOthers: 'Plugs/Others',
    carbonEmissions: 'TODAY\'S CARBON EMISSIONS',
    equivalentTrees: 'Eq. to planting',
    climateSummary: 'Climate Monitoring Summary',
    avgTemperature: 'Average Temperature',
    minTemperature: 'Min Temperature',
    maxTemperature: 'Max Temperature',
    avgHumidity: 'Average Humidity',
    minHumidity: 'Min Humidity',
    maxHumidity: 'Max Humidity',
    totalDevices: 'Total Devices',
    onlineDevicesCount: 'Online Devices',
    fullscreen: 'Fullscreen',
    exitFullscreen: 'Exit Fullscreen',
  },

  climate: {
    // Page Title
    title: 'Smart Climate Monitoring Center',
    titleEn: 'Climate Monitoring Center',
    environmentMonitoring: 'Environmental Monitoring',

    // Status Labels
    demoMode: 'DEMO MODE',
    lastUpdate: 'Last update:',
    auto: 'Auto',
    manual: 'Manual',
    alertCenter: 'Alert Center',

    // Summary Stats
    avgTemp: 'Avg Temp',
    avgHumidity: 'Avg Humidity',
    tempRange: 'Temp Range',
    humidityRange: 'Humidity Range',
    devices: 'Devices',

    // Loading State
    loading: 'Loading climate devices...',

    // Error Messages
    noDevicesImported: 'No devices imported. Please go to Device Manager to import devices.',
    loadError: 'Failed to load climate devices. Please check your connection and try again.',
    tryAgain: 'Try Again',

    // Empty State
    noSensorsFound: 'No climate sensors found',
    configureDevices: 'Please configure your climate devices in Settings',
    goToSettings: 'Go to Settings',

    // Footer
    poweredBy: 'Powered by Ultron Turing',
    version: 'Ver:',
    build: 'Build:',

    // Metrics
    temperature: 'Temperature',
    humidity: 'Humidity',
    co2: 'CO2',
    tvoc: 'TVOC',
    pm25: 'PM2.5',
    illuminance: 'Illuminance',
    pressure: 'Pressure',

    // Units
    celsius: '°C',
    fahrenheit: '°F',
    percent: '%',
    ppm: 'ppm',
    lux: 'lux',
    hPa: 'hPa',

    // Status
    comfortable: 'Comfortable',
    good: 'Good',
    moderate: 'Moderate',
    poor: 'Poor',
    veryPoor: 'Very Poor',

    // Sensor Types
    temperatureSensor: 'Temperature Sensor',
    humiditySensor: 'Humidity Sensor',
    co2Sensor: 'CO2 Sensor',
    airQualitySensor: 'Air Quality Sensor',

    // Messages
    noSensors: 'No Sensors',
    sensorOffline: 'Sensor Offline',

    // Card
    temp: 'Temp',
    humi: 'Humi',
    clickToViewHistory: 'Click to view historical data',
  },

  alerts: {
    title: 'Alert Management',
    alertManagement: 'Alert Management',

    // Alert Types
    critical: 'Critical',
    warning: 'Warning',
    info: 'Info',

    // Alert Status
    active: 'Active',
    acknowledged: 'Acknowledged',
    resolved: 'Resolved',

    // Actions
    acknowledge: 'Acknowledge',
    resolve: 'Resolve',
    mute: 'Mute',
    unmute: 'Unmute',

    // Settings
    alertRules: 'Alert Rules',
    createAlert: 'Create Alert',
    newAlert: 'New Alert',
    createNewAlert: 'Create New Alert',
    createFirstAlert: 'Create Your First Alert',
    editAlert: 'Edit Alert',
    updateAlert: 'Update Alert',
    deleteAlert: 'Delete Alert',
    testAlert: 'Test Alert',
    alertName: 'Alert Name',

    // UI Actions
    back: 'Back',
    loadingAlerts: 'Loading alerts...',
    noAlertsConfigured: 'No alerts configured',
    enable: 'Enable',
    disable: 'Disable',
    edit: 'Edit',
    delete: 'Delete',
    deleteConfirm: 'DELETE',
    cancel: 'Cancel',

    // Conditions
    condition: 'Condition',
    threshold: 'Threshold',
    above: 'Above',
    below: 'Below',
    equals: 'Equals',
    greaterOrEqual: 'Greater or Equal',
    lessOrEqual: 'Less or Equal',

    // Form Fields
    device: 'Device',
    selectDevice: 'Select a device',
    selectDeviceFirst: 'Please select a device first',
    noMetricsAvailable: 'No metrics available',
    metric: 'Metric',
    temperature: 'Temperature',
    humidity: 'Humidity',
    battery: 'Battery',
    presence: 'Presence',
    detected: 'Detected (Occupied)',
    notDetected: 'Not Detected (Unoccupied)',
    voltage: 'Voltage',
    current: 'Current',
    power: 'Real-time Power',
    energy: 'Cumulative Energy',
    powerState: 'Device State',
    onlineStatus: 'Online Status',
    lux: 'Illuminance (Lux)',

    // State Conditions
    on: 'On',
    off: 'Off',
    changed: 'State Changed',
    online: 'Online',
    offline: 'Offline',

    thresholdValue: 'Threshold Value',
    severityLevel: 'Severity Level',
    major: 'MAJOR',

    // Notifications
    notification: 'Notification',
    notificationChannels: 'Notification Channels',
    websocket: 'WebSocket',
    line: 'LINE',
    email: 'Email',
    browserWebSocket: 'Browser (WebSocket)',
    toastNotification: 'In-app Notification (Toast)',
    systemNotification: 'System Notification (Requires Permission)',
    lineNotify: 'LINE Notify',

    // Trigger Modes
    triggerMode: 'Trigger Mode',
    edgeTrigger: 'Edge Trigger',
    continuous: 'Continuous',
    intervalReminder: 'Interval Reminder',
    edgeTriggerDesc: 'Notify only when crossing threshold, send recovery notification when status changes',
    continuousDesc: 'Notify every time checked (for critical alerts)',
    intervalReminderDesc: 'Remind every N minutes (avoid notification spam)',

    // Time Units
    minutes: 'minutes',
    hour: 'hour',
    hours: 'hours',
    onceDaily: 'Once daily (every 24 hours)',

    // Battery Alerts
    batteryAlert: 'Battery Alert',
    lowBattery: 'Low Battery',
    batteryLevel: 'Battery Level',
    batteryThreshold: 'Battery Threshold',
    
    // Door/Motion Sensors
    doorState: 'Door State',
    motion: 'Motion',
    opened: 'Opened',
    closed: 'Closed',
    
    // Curtain/Blind
    curtain: 'Curtain',
    blind: 'Blind',
    rollerShade: 'Roller Shade',
    openPercent: 'Open Percent',
    fullyOpen: 'Fully Open',
    fullyClosed: 'Fully Closed',
  },

  hvac: {
    // Page Title
    title: 'Smart HVAC Control Center',
    titleEn: 'HVAC Control Center',

    // Status Labels
    ultronTuring: 'Ultron Turing',
    demoMode: 'DEMO MODE',
    lastUpdate: 'Last update',
    auto: 'Auto',
    manual: 'Manual',
    alertCenter: 'Alert Center',

    // Summary Stats
    totalUnits: 'Total Units',
    active: 'Active',
    avgTemp: 'Avg Temp',
    ai: 'AI',
    learning: 'Learning',
    aiActive: 'Active',
    off: 'Off',
    status: 'Status',

    // Device Types
    thSensor: 'TH Sensor',
    presenceSensor: 'Presence Sensor',
    presenceLuxSensor: 'Presence & Lux Sensor',
    offline: 'OFFLINE',

    // Drag and Drop
    dragToReorder: 'Drag to reorder',

    // Modes
    cool: 'COOL',
    heat: 'HEAT',
    fan: 'FAN',
    fanOnly: 'FAN',
    dry: 'DRY',
    normal: 'NORMAL',
    natural: 'NATURAL',
    sleep: 'SLEEP',

    // Fan Speeds
    speed: 'Speed',
    low: 'LOW',
    medium: 'MEDIUM',
    high: 'HIGH',

    // Temperature
    set: 'Set',

    // Empty State
    noDevicesFound: 'No HVAC Units Found',
    noDevicesConfigured: 'No AC units are configured in your system.',

    // Loading
    loadingDevices: 'Loading HVAC units...',

    // Notification Messages
    noDevicesImported: 'No devices imported. Please go to Device Manager to import devices.',
    devicesFound: 'Found {{count}} HVAC devices',
    failedToLoad: 'Failed to load HVAC devices',

    // AI Tooltip
    aiAppliedTo: 'AI applied to',
    aiNotEnabled: 'AI not enabled',

    // Footer
    poweredBy: 'Powered by Ultron Turing',
    version: 'Ver:',
    build: 'Build:',
  },

  lighting: {
    // Page Title
    title: 'Smart Lighting Control Center',
    titleEn: 'Lighting AI Controller',

    // Status Labels
    realtime: 'Real-time',
    auto: 'Auto',
    manual: 'Manual',

    // Tooltips
    wsConnected: 'WebSocket connected - {count} device(s) subscribed',
    wsConnecting: 'WebSocket connecting - {count} device(s) pending',
    autoRefreshOn: 'Auto refresh is ON',
    autoRefreshOff: 'Auto refresh is OFF',
    manualRefresh: 'Manual Refresh',
    notifications: 'Notifications',

    // Notification Messages
    refreshing: 'Refreshing lighting data...',

    // Summary Stats
    totalUnits: 'Total Units',
    active: 'Active',
    avgBrightness: 'Avg Brightness',
    online: 'Online',

    // Loading State
    loading: 'Loading lighting units...',

    // Empty State
    noDevices: 'No Lighting Devices',
    noDevicesDesc: 'Import your lighting devices and sensors to start controlling them',
    importDevices: 'Import Devices',

    // Footer
    poweredBy: 'Powered by Ultron Turing',
    version: 'Ver:',
    build: 'Build:',
  },

  settings: {
    title: 'Settings',

    // Section Titles
    company: 'Company',
    dashboard: 'Dashboard',
    deviceCategorization: 'Device Categorization',
    notification: 'Notifications',
    cache: 'Cache',
    language: 'Language',
    themes: 'Themes',

    // Theme Editor
    themesTitle: 'Device Modal Themes',
    themesDescription: 'Customize modal appearance for different device types',
    templateName: 'Template Name',
    internalId: 'Internal ID',
    statusIndicator: 'Status Indicator',
    sensorDisplay: 'Sensor Display',
    sensorChart: 'Sensor Chart',
    occupancyTimeline: 'Occupancy Timeline',
    deviceIcon: 'Device Icon',
    mainIcon: 'Main Icon',
    controlStyles: 'Control Styles',
    dragToReorder: 'Drag to reorder',
    resetDefault: 'Reset Default',
    saveAs: 'Save as...',
    saveAndApply: 'Save & Apply',
    livePreview: 'Live Preview',
    currentlyApplied: 'Currently Applied',
    editTemplate: 'Edit',
    applyTemplate: 'Apply',
    applied: 'Applied',

    // Company Info
    companyInfo: 'Company Information',
    logo: 'Company Logo',
    favicon: 'Favicon',
    companyName: 'Company Name',
    currentLogo: 'Current Company Logo',
    uploadLogo: 'Upload Logo',
    uploadNewLogo: 'Upload New Logo',
    uploadFavicon: 'Upload Favicon',
    removeLogo: 'Remove Logo',
    removeFavicon: 'Remove Favicon',
    currentFavicon: 'Current Favicon',
    uploadNewFavicon: 'Upload New Favicon',
    chooseFile: 'Choose File',
    uploading: 'Uploading...',
    logoFileFormats: 'JPG or PNG, any aspect ratio, auto-resized to fit',
    faviconLabel: 'Favicon (Browser Tab Icon)',
    faviconFileFormats: 'JPG, PNG or ICO, auto-resized to 32x32',

    // Dashboard Settings
    dashboardSettings: 'Dashboard Settings',
    theme: 'Theme',
    light: 'Light',
    dark: 'Dark',
    timezone: 'Timezone',
    selectTimezone: 'Select Timezone',
    timezoneNote: 'Timezone setting is used to correctly display and calculate electricity usage periods',
    refreshInterval: 'Refresh Interval',
    gridCardRefreshInterval: 'Dashboard Grid Card Auto Refresh Interval',
    chartRefreshInterval: 'Data Chart Auto Refresh Interval',
    seconds: 'seconds',
    minutes: 'minutes',
    hour: 'hour',
    recommended: '(Recommended)',
    autoRefresh: 'Auto Refresh',

    // Language Settings
    selectLanguage: 'Select Language',
    currentLanguage: 'Current Language',
    traditionalChinese: '繁體中文',
    english: 'English',

    // System Notifications
    systemNotifications: 'System Notifications',
    lowBatteryNotification: 'Low Battery Notification',
    batteryAlert: 'Battery Alert',
    batteryAlertEnabled: 'Battery Alert Enabled',
    batteryAlertDisabled: 'Battery Alert Disabled',
    batteryMonitorDescription: 'Monitor all imported devices with battery and receive daily alerts when battery level drops below threshold.',
    batteryDevicesFound: 'Battery Devices Found:',
    batteryStatus: 'Battery Status',
    batteryDevicesNote: 'All devices with battery capability will be automatically monitored',
    batteryThreshold: 'Battery Threshold',
    batteryThresholdPercent: 'Battery Threshold (%)',
    batteryThresholdNote: 'Alert when battery level drops below this percentage (5-50%)',
    saveConfiguration: 'Save Configuration',
    testAlert: 'Test Alert',
    testAlertSuccess: 'Test Alert Sent',
    alertCenterNote: 'Alerts appear in Alert Center and as toast notifications. All devices with battery are monitored automatically.',

    // System Notification Settings
    notificationSettings: 'System Notification Settings',
    notificationSettingsDescription: 'Configure how you receive different types of notifications',
    alertNotification: 'Alert Notification',
    automationNotification: 'Automation Notification',
    batteryNotification: 'Battery Notification',
    websocketNotification: 'Web Notification',
    emailNotification: 'Email',
    useCustomEmailAddress: 'Use Custom Email Address',
    saveNotificationSettings: 'Save Notification Settings',
    testEmail: 'Send Test Email',
    testEmailSuccess: 'Test email sent. Please check your inbox.',
    testEmailFailed: 'Failed to send test email',
    noEmailConfigured: 'Please configure an email address first',

    // Cache Management
    cacheManagement: 'Cache Management',
    cacheManagementDescription: 'Clear cached data to free up browser storage space if you\'re experiencing issues.',
    clearCache: 'Clear Cache',
    clearIncrementalData: 'Clear Incremental Data',
    clearAllCache: 'Clear All Cache',
    clearAllData: 'Clear All Data',
    confirmClear: 'Are you sure you want to clear all cache data?',
    confirmClearIncrementalData: 'This will clear all incremental sensor data cache. Continue?',
    confirmClearAllCache: 'This will clear ALL cached data except your settings. Continue?',
    cacheCleared: 'Cache Cleared',
    clearedIncrementalCaches: 'Cleared {count} incremental data caches',
    clearedCacheItems: 'Cleared {count} cache items',
    storageUsed: 'Storage used:',

    // Device Categorization
    deviceCategorizationTitle: 'Device Categorization',
    deviceCategorizationDescription: 'Assign each device to a category for data aggregation and display in the overview dashboard.',
    deviceCategory: 'Device Category',
    selectCategory: 'Select Category',
    categoryEnergy: 'Energy',
    categoryClimate: 'Climate',
    categoryHVAC: 'HVAC',
    categoryLighting: 'Lighting',
    deviceName: 'Device Name',
    deviceSN: 'Device SN',
    currentCategory: 'Current Category',
    autoDetected: 'Auto Detected',
    resetToDefault: 'Reset to Default',
    saveCategories: 'Save Categories',
    categoriesSaved: 'Device categories saved successfully',
    categoriesSaveFailed: 'Failed to save device categories',
    noDevicesAvailable: 'No devices available. Please import devices first.',
    loadingDevices: 'Loading devices...',

    // Authentication
    authentication: 'Authentication',
    authMode: 'Auth Mode',
    oauth: 'OAuth 2.0',
    apiKey: 'API Key',
    appId: 'App ID',
    groupId: 'Group ID',
    credentials: 'Credentials',

    // Messages
    saveSuccess: 'Settings Saved',
    saveFailed: 'Save Failed',
    uploadSuccess: 'Upload Successful',
    uploadFailed: 'Upload Failed',
    deleteSuccess: 'Deleted Successfully',
    deleteFailed: 'Delete Failed',
  },

  deviceModal: {
    title: 'Device Details',
    deviceInfo: 'Device Information',
    deviceName: 'Device Name',
    deviceId: 'Device ID',
    deviceSN: 'Device SN',
    deviceType: 'Device Type',
    location: 'Location',

    // Edit Name
    editName: 'Edit Name',
    saveName: 'Save Name',
    deviceNameCannotBeEmpty: 'Device name cannot be empty',
    saveNameFailed: 'Failed to save name',

    // Status
    status: 'Status',
    online: 'Online',
    offline: 'Offline',
    lastSeen: 'Last Seen',

    // Controls
    controls: 'Controls',
    powerOn: 'Power On',
    powerOff: 'Power Off',

    // Data
    currentData: 'Current Data',
    historicalData: 'Historical Data',

    // Sensor Modal
    sensorData: 'Sensor Data',
    realTimeData: 'Real-time Data',
    occupancy: 'Occupancy',
    occupied: 'Occupied',
    vacant: 'Vacant',
    motion: 'Motion Detection',
    detected: 'Detected',
    notDetected: 'Not Detected',

    // Light Control Modal
    lightControl: 'Light Control',
    brightness: 'Brightness',
    colorTemp: 'Color Temperature',
    warmWhite: 'Warm White',
    coolWhite: 'Cool White',
    rgb: 'RGB Color',
    presets: 'Presets',

    // Power Control
    deviceControl: 'Device Control',
    turnOn: 'Turn On Device',
    turnOff: 'Turn Off Device',
  },

  // Device Detail Modal (Three-phase and Max Current Settings)
  deviceDetail: {
    totalPhase: 'Total',
    threePhaseDetails: 'R/S/T Phase Details',
    phaseR: 'Phase R',
    phaseS: 'Phase S',
    phaseT: 'Phase T',
    realTimeData: 'Real-time Data',
    maxCurrentSetting: 'Maximum Current Setting',
    maxCurrentHint: 'Set maximum current limit for load monitoring and overload alerts',
    maxCurrentPlaceholder: 'Enter maximum current (A)',
    maxCurrentMustBePositive: 'Maximum current must be a positive number',
    saveMaxCurrentFailed: 'Failed to save max current. Please try again.',
    overloadWarning: 'Overload Warning',
    overloadMessage: 'Current exceeds the set maximum current limit',
    notSet: 'Not Set',
    edit: 'Edit',
    clear: 'Clear',
  },

  groupSelector: {
    selectGroup: 'Select Location',
    currentGroup: 'Current Group',
    switchGroup: 'Switch Group',
    loadingGroups: 'Loading Groups...',
    noGroups: 'No Groups Available',
  },

  errors: {
    // General Errors
    generalError: 'An error occurred',
    networkError: 'Network Error',
    serverError: 'Server Error',
    authError: 'Authentication Error',
    permissionDenied: 'Permission Denied',
    notFound: 'Resource Not Found',
    timeout: 'Request Timeout',

    // API Errors
    apiCallFailed: 'API Call Failed',
    invalidResponse: 'Invalid Response',
    invalidData: 'Invalid Data',

    // Device Errors
    deviceNotFound: 'Device Not Found',
    deviceOffline: 'Device Offline',
    deviceControlFailed: 'Device Control Failed',

    // Data Errors
    loadDataFailed: 'Failed to Load Data',
    saveDataFailed: 'Failed to Save Data',
    deleteDataFailed: 'Failed to Delete Data',

    // Validation Errors
    invalidInput: 'Invalid Input',
    requiredField: 'This field is required',
    invalidFormat: 'Invalid Format',

    // Retry
    pleaseTryAgain: 'Please try again',
    retryLater: 'Please try again later',
  },

  time: {
    // Days of Week
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',

    // Months
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',

    // Relative Time
    now: 'Now',
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    nextWeek: 'Next Week',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    nextMonth: 'Next Month',

    // Time Units
    seconds: 'seconds',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    weeks: 'weeks',
    months: 'months',
    years: 'years',

    // Time Format
    ago: 'ago',
    later: 'later',
  },

  // IntelliSpace
  intelliSpace: {
    title: 'IntelliSpace',
    boardName: 'Smart Space Management - The Only Dashboard You Need',
    overview: 'Overview',
    control: 'Control',
    deviceManager: 'Device Manager',
    automation: 'Automation',
    
    // Overview
    totalDevices: 'Total Devices',
    totalPower: 'Total Power',
    avgTemp: 'Avg Temperature',
    avgHumidity: 'Avg Humidity',
    occupancy: 'Occupancy',
    activeHvac: 'Active HVAC',
    activeSwitches: 'Active Switches',
    switchControl: 'Switch Control',
    
    // Device Types
    powerMeters: 'Power Meters',
    thSensors: 'Temperature & Humidity',
    presenceSensors: 'Presence Sensors',
    hvacUnits: 'HVAC Units',
    switches: 'Switches',
    meters: 'meters',
    sensors: 'sensors',
    
    // Status
    occupied: 'Occupied',
    vacant: 'Vacant',
    running: 'running',
    noHvac: 'No HVAC',
    noSensors: 'No sensors',
    noSwitches: 'No switches',
    noPowerMeters: 'No power meters',
    
    // Selector Modals
    selectPowerMeters: 'Select Power Meters',
    selectSwitches: 'Select Switches',
    selectHvac: 'Select HVAC',
    selectAll: 'Select All',
    clearSelection: 'Clear Selection',
    allMetersIncluded: 'All meters included',
    allSwitchesIncluded: 'All switches included',
    allHvacIncluded: 'All HVAC included',
    turnAllOn: 'Turn All ON',
    turnAllOff: 'Turn All OFF',
    
    // Charts
    todayPowerConsumption: 'Today\'s Power Consumption',
    todayClimate: 'Today\'s Temperature & Humidity',
    metersSelected: 'meters selected',
    timeRange: 'Time Range',
    currentPower: 'Current Power',
    
    // Automation
    automationTitle: 'Automation Rules',
    automationDescription: 'Create automation rules to control your devices based on conditions like time, occupancy, or sensor readings.',
    createRule: 'Create Rule',
    
    // Messages
    noDevicesImported: 'No devices imported. Please go to Device Manager to import devices.',
    loadError: 'Failed to load devices. Please check your connection and try again.',
    loading: 'Loading devices...',
    noDevices: 'No devices found',
    importDevicesHint: 'Go to Device Manager to import devices',
    openDeviceManager: 'Open Device Manager',
    
    // Empty State
    welcomeTitle: 'Welcome to IntelliSpace',
    noDevicesDescription: 'You haven\'t imported any devices yet.\nGo to Device Manager to select and import devices you want to monitor.',
    featureClimate: 'Climate Monitor',
    featurePower: 'Power Analysis',
    featureHvac: 'HVAC Control',
    goToDeviceManager: 'Go to Device Manager',
    or: 'or',
    refreshDevices: 'Refresh',
    today: 'Today',
    yesterday: 'Yesterday',
    lastWeek: 'Last Week',
    dailyComparison: 'Daily Trend & Comparison',
  },

  // Power Consumption 24H
  power24h: {
    title: 'Real-time Power',
    subtitle: 'Timezone: {{timezone}}',
    total: 'Total Power',
    hvac: 'HVAC Power',
    lighting: 'Lighting Power',
    limit: 'Limit',
    setLimit: 'Set Limit',
    limitValue: 'Limit Value',
    noLimitPlaceholder: 'Leave empty for no limit',
    limitHint: 'Chart turns red when usage exceeds 80%',
    noDevice: 'None',
    allDevices: 'All',
    devices: 'meters',
    selectAll: 'Select All',
    clear: 'Clear',
    noPowerMeters: 'No power meters available',
    settings: 'Settings',
    deviceSelection: 'Device Selection',
    limitSettings: 'Limit Settings',
    selectDevices: 'Select Devices',
    vsYesterday: 'vs Yesterday',
    vsLastWeek: 'vs Last Week',
    vsLastMonth: 'vs Last Month',
    summary: 'Power Summary',
    totalEnergy: 'Total Energy',
    averageEnergy: 'Average Energy',
    peakTime: 'Peak Time',
    peakPower: 'Peak Power',
    // Three-phase meter
    threePhase: '3-Phase',
    phaseR: 'Phase R',
    phaseS: 'Phase S',
    phaseT: 'Phase T',
    totalPhase: 'Total',
    power: 'Power',
    voltage: 'Voltage',
    current: 'Current',
  },
};
